import * as Sentry from '@sentry/browser'
import { useMutation } from '@tanstack/react-query'
import {
  TemplatesApi,
  UpdateTemplateV3Body,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  HTTPError,
  handleHTTPError,
} from 'src/state/middleware/saga/handleHttpError'
import { store } from 'src/state/store'

type UpdateTemplateV3Params = {
  templateId: number
  body: UpdateTemplateV3Body
}

export const useMutationUpdateTemplateV3 = () => {
  return useMutation<void, HTTPError, UpdateTemplateV3Params>({
    mutationFn: async ({ templateId, body }) => {
      return await baseClient
        .getApi(TemplatesApi)
        .updateTemplateV3({
          templateId,
          updateTemplateV3Body: body,
        })
        .catch(e => {
          Sentry.captureException(e, {
            extra: {
              templateId,
              requestBody: body,
              templateState: store.getState().templatesState,
            },
          })
          return handleHTTPError(e)
        })
    },
  })
}
